import { createContext } from 'react';
import type { useAuthProvider } from './useAuthProvider.ts';

type AuthContextValue = ReturnType<typeof useAuthProvider>;

/**
 * {@link AuthContext} shares out some auth state and methods to the rest of the app.
 */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
